export const FALLBACK_SEO = {
    title: 'The Realest',
    description: 'The Realest',
};

export const MOBILE_MAX_WIDTH = 767;
